import { useCallback } from 'react';
import { Node, NodeToolbar, useReactFlow, useStore } from 'reactflow';
import { createGroupNode } from '../../nodes/group-node/group-node.helper';

import './selected-topics-toolbar.scss';

// const selectedNodesSelector = (state: any) =>
//   Array.from(state.nodeInternals.values())
//     .filter((node: any) => node.selected)
//     .map((node: any) => node.id);

const selectedTopicNodesSelector = (state: any) =>
  Array.from(state.nodeInternals.values())
    .filter((node: any) => node.selected && node.type !== 'group' && !(node.parentNode as string)?.includes('group'))
    .map((node: any) => node.id);

export default function SelectedTopicsToolbar(props: any) {
  // const selectedNodeIds: string[] = useStore(selectedNodesSelector);
  const selectedNodeIds: string[] = useStore(selectedTopicNodesSelector);
  const isVisible = selectedNodeIds.length > 1;

  const reactFlowInstance = useReactFlow();

  const getNodes = useCallback((topicIds: string[]) => {
    return topicIds
      .map(topicId => reactFlowInstance.getNode(topicId))
      .filter((node): node is Node => !!node);
  }, [reactFlowInstance]);

  return (
    <NodeToolbar
      className='node-toolbar'
      nodeId={selectedNodeIds}
      isVisible={isVisible}
    >
      {/* <button
        type='button'
        onClick={() => props.recommendSubtopics(selectedNodeIds)}
      >
        Recommend Subtopics
      </button> */}
      <button
        type='button'
        onClick={() => createGroupNode(reactFlowInstance, getNodes(selectedNodeIds))}
      >
        Form Group
      </button>
    </NodeToolbar>
  );
}